var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCulinary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-culinary",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39709",
    "data-name": "Path 39709",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39712",
    "data-name": "Path 39712",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "restaurant_FILL0_wght600_GRAD0_opsz48",
    d: "M11.669,30.878V18.594a5.649,5.649,0,0,1-3.23-1.874A5.265,5.265,0,0,1,7.05,13.072V3.7H9.493v9.372h2.176V3.7h2.41v9.372h2.176V3.7h2.477v9.372a5.23,5.23,0,0,1-1.406,3.648,5.725,5.725,0,0,1-3.247,1.874V30.878Zm14.526,0V20.168H22.346V9.758a5.781,5.781,0,0,1,1.74-4.418A6.367,6.367,0,0,1,28.639,3.7V30.878Z",
    transform: "translate(7.07 9.985)",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCulinary);
export default __webpack_public_path__ + "static/media/ic-culinary.9aa5fc2dad39c11af558002b2e7a6eec.svg";
export { ForwardRef as ReactComponent };